<template>
    <section class="container bg-white my-5 p-5">

        <form method="post" :action="formAction" v-on:submit.prevent="formSubmit">

            <div class="row justify-content-center align-items-top">

                <div class="col-12">
                    <p><b>Anrede</b></p>
                    <div class="form-group" id="salutation">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="employee[salutation]" id="salutationMr"
                                value="MR" v-model="fields.employee.salutation">
                            <label class="form-check-label" for="salutationMr">Herr</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="employee[salutation]" id="salutationMs"
                                v-model="fields.employee.salutation" value="MS">
                            <label class="form-check-label" for="salutationMs">Frau</label>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="form-row">
                        <div class="col-6 form-group">
                            <label for="first_name">Vorname *</label>
                            <input required type="text" name="employee[first_name]" id="first_name" class="form-control"
                                placeholder="Vorname" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.employee.first_name">
                        </div>
                        <div class="col-6 form-group">
                            <label for="last_name">Nachname *</label>
                            <input required type="text" name="employee[last_name]" id="last_name" class="form-control"
                                placeholder="Nachname" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.employee.last_name">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-12 col-md-6 form-group">
                            <label for="employeeEmail">Persönliche E-Mail-Adresse *</label>
                            <input required v-on:keyUp="checkEmail" v-model="fields.employee.email" type="email"
                                name="employee[email]" id="employeeEmail" class="form-control"
                                placeholder="max@beispiel.de" v-on:change="validate" v-on:keyup="validate">
                        </div>

                        <div class="col-12 col-md-6 form-group">
                            <label for="employeeTelephone">Persönliche Telefonnummer *</label>
                            <input required type="tel" name="employee[telephone]" id="employeeTelephone"
                                class="form-control" placeholder="+49123456789" v-on:change="validate"
                                v-on:keyup="validate" v-model="fields.employee.telephone">
                        </div>
                    </div>

                    <password-field v-on:passwordIsInvalid="setPasswordAsInvalid"
                        v-on:passwordIsValid="setPasswordAsValid"
                        v-on:update:password="fields.employee.password = $event"
                        v-on:update:passwordConfirmation="fields.employee.password_confirmation = $event"
                        :label="'Passwort'" :id="'password'" name="'producer[password]'"></password-field>
                </div>

                <div class="col-12 col-md-6">
                    <div class="form-row">
                        <div class="col-12 form-group">
                            <label for="producerName">Firma *</label>
                            <input required type="text" name="producer[name]" id="producerName" placeholder="Firma"
                                class="form-control" v-model="fields.producer.name">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-8 form-group">
                            <label for="street">Straße *</label>
                            <input required type="text" name="address[street]" id="street" class="form-control"
                                placeholder="Straße" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.address.street">
                        </div>
                        <div class="col-4 form-group">
                            <label for="house_number">Nr. *</label>
                            <input required type="text" name="address[house_number]" id="house_number"
                                class="form-control" placeholder="Nr." v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.address.house_number">
                        </div>
                        <div id="addressBlock" class="col-12">
                            <address-line v-on:newAddressLine="addAddressline"
                                v-on:removeAddressLine="removeAddressline"></address-line>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-4 form-group">
                            <label for="postal_code">Postleitzahl (PLZ) *</label>
                            <input required type="text" name="address[postal_code]" id="postal_code"
                                class="form-control" placeholder="Postleitzahl" v-on:change="validate"
                                v-on:keyup="validate" v-model="fields.address.postal_code">
                        </div>
                        <div class="col-8 form-group">
                            <label for="city">Ort / Stadt *</label>
                            <input required type="text" name="address[city]" id="city" class="form-control"
                                placeholder="Ort / Stadt" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.address.city">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-12 col-md-6 form-group">
                            <label for="producerEmail">E-Mail-Adresse</label>
                            <input v-on:keyUp="checkEmail" v-model="fields.producer.email" type="email"
                                name="producer[email]" id="producerEmail" class="form-control"
                                placeholder="max@beispiel.de" v-on:change="validate" v-on:keyup="validate">
                        </div>

                        <div class="col-12 col-md-6 form-group">
                            <label for="producerTelephone">Telefonnummer</label>
                            <input type="tel" name="producer[tel]" id="producerTelephone" class="form-control"
                                placeholder="+49123456789" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.producer.tel">
                        </div>

                        <div class="col-12 col-md-6 form-group">
                            <label for="producerWebsite">Website</label>
                            <input type="url" name="producer[website]" id="producerWebsite" class="form-control"
                                placeholder="https://www.beispiel.de" v-on:change="validate" v-on:keyup="validate"
                                v-model="fields.producer.website">
                        </div>
                    </div>
                </div>
            </div>


            <csrf-field :token="csrfToken" />
            <input type="hidden" v-model="fields.address.country" name="address[country]" value="DE">

            <div class="row">
                <div class="col-12">
                    <p class="form-text text-muted">Mit <b>*</b> markierte Felder sind Pflichtangaben.</p>
                    <button type="submit" class="btn btn-primary" v-if="form_valid">Weiter</button>
                    <button type="submit" class="btn btn-primary" disabled v-else>Weiter</button>
                </div>
            </div>

        </form>

    </section>
</template>

<script>
    export default {
        name: "ProducerRegistrationForm",
        props: ['csrfToken', 'formAction'],
        data() {
            return {
                subscription: "",
                vehicle: "",
                fields: {
                    employee: {
                        salutation: "MR",
                        first_name: "",
                        last_name: "",
                        email: "",
                        telephone: "",
                        password: "",
                        password_confirmation: ""
                    },
                    address: {
                        street: "",
                        house_number: "",
                        postal_code: "",
                        city: "",
                        country: "DE",
                        additional: []
                    },
                    producer: {
                        name: "",
                        email: "",
                        website: "",
                        tel: ""
                    }
                },
                validation: {
                    first_name: false,
                    last_name: false,
                    salutation: true,
                    street: false,
                    house_number: false,
                    postal_code: false,
                    city: false,
                    employeeEmail: false,
                    employeeTelephone: false,
                    password: false,
                    name: false
                },
                form_valid: false
            }
        },
        computed: {
            presetDate: {
                get() {
                    return this.getCurrentDayFromPast();
                },
                set(newValue) {
                    this.fields.producer.birthday = newValue;
                }
            }
        },
        methods: {
            formSubmit() {
                axios.post(this.formAction, {
                    producer: this.fields.producer,
                    address: this.fields.address,
                    employee: this.fields.employee
                })
                    .then(function (response) {
                        console.log(response);
                        window.location.href = response.data.nextUrl
                    })
                    .catch(function (error) {
                        console.warn(error.getMessage());
                    })
            },
            addAddressline(payload) {
                this.fields.address.additional[payload.id] = payload.value;
            },
            removeAddressline(payload) {
                console.log(payload);
                this.fields.address.additional.splice(payload, 1);
            },
            setSubscription(payload) {
                this.subscription = payload;
                console.log(payload);
            },
            checkEmail() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            setPasswordAsValid() {
                this.validation.password = true;
                this.enableButton();
            },
            setPasswordAsInvalid() {
                this.validation.password = false;
                this.enableButton();
            },
            setPassword() {
            },
            setPasswordConfirmation() {
            },
            validate() {
/*
                first_name: false,
                    last_name: false,
                    salutation: true,
                    street: false,
                    house_number: false,
                    postal_code: false,
                    city: false,
                    employeeEm
                */

                this.validation.first_name = this.fields.employee.first_name ? true : false;
                this.validation.last_name = this.fields.employee.last_name ? true : false;
                this.validation.salutation = this.fields.employee.salutation ? true : false;
                this.validation.street = this.fields.address.street ? true : false;
                this.validation.house_number = this.fields.address.house_number ? true : false;
                this.validation.postal_code = this.fields.address.postal_code ? true : false;
                this.validation.city = this.fields.address.city ? true : false;
                this.validation.employeeEmail = this.fields.employee.email ? true : false;
                this.validation.employeeTelephone = this.fields.employee.telephone ? true : false;
                this.validation.name = this.fields.producer.name ? true : false;
                this.enableButton();
            },
            enableButton() {
                let formIsValid = true;
                $.each(this.validation, function (key, value) {
                    if (value === false) {
                        formIsValid = false;
                    }
                });
                this.form_valid = formIsValid;
            }
        },
        mounted() {
            console.log("Partner-Registrierung geladen...");
            this.validate();
        }
    }
</script>

<style scoped>

</style>
